import React from 'react';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDBox, FDPaper, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';
import { Layout } from './Layout';

export const ReferralPageInfoBoxes = ({ collection }) => {
  const isMobile = useMobileLayout();

  return (
    <FDBox paddingY={2}>
      <FDPaper appearance={'flat'}>
        <FDStack direction="column" spacing={isMobile ? 2 : 3} padding={isMobile ? 3 : 4}>
          <MetaControlField attr={'howToTitle'} />
          <FDStack direction={isMobile ? 'column' : 'row'} spacing={2} flex={1}>
            <MetaCollectionRenderer
              collection={collection}
              layout={Layout}
            />
          </FDStack>
        </FDStack>
      </FDPaper>
    </FDBox>
  );
};

ReferralPageInfoBoxes.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};
